// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';
import { PatchConfigData, PatchConfigDataT } from '../tbs/patch-config-data.js';


export class PatchConfigAction implements flatbuffers.IUnpackableObject<PatchConfigActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):PatchConfigAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPatchConfigAction(bb:flatbuffers.ByteBuffer, obj?:PatchConfigAction):PatchConfigAction {
  return (obj || new PatchConfigAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPatchConfigAction(bb:flatbuffers.ByteBuffer, obj?:PatchConfigAction):PatchConfigAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new PatchConfigAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.LobbyPatchConfig;
}

data(obj?:PatchConfigData):PatchConfigData|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new PatchConfigData()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startPatchConfigAction(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.LobbyPatchConfig);
}

static addData(builder:flatbuffers.Builder, dataOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, dataOffset, 0);
}

static endPatchConfigAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): PatchConfigActionT {
  return new PatchConfigActionT(
    this.type(),
    (this.data() !== null ? this.data()!.unpack() : null)
  );
}


unpackTo(_o: PatchConfigActionT): void {
  _o.type = this.type();
  _o.data = (this.data() !== null ? this.data()!.unpack() : null);
}
}

export class PatchConfigActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.LobbyPatchConfig,
  public data: PatchConfigDataT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const data = (this.data !== null ? this.data!.pack(builder) : 0);

  PatchConfigAction.startPatchConfigAction(builder);
  PatchConfigAction.addType(builder, this.type);
  PatchConfigAction.addData(builder, data);

  return PatchConfigAction.endPatchConfigAction(builder);
}
}
